import styled from 'styled-components'

import colors from './colors'

const Badge = styled.div`
  display: inline-block;
  padding: .25rem .5rem;
  font-size: .8rem;
  font-weight: 500;
  border-radius: .25rem;
  color:      ${p => p.red ? colors.red      : p.orange ? colors.orange      : colors.secondaryText};
  background: ${p => p.red ? colors.lightRed : p.orange ? colors.lightOrange : colors.lightGray};
`

export {
  Badge,
}



// WEBPACK FOOTER //
// ./src/styles/badges.js